import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqn } from '@/shared/lib/format';

export type GlossaryTermBasic = {
  id: string;
  name: string;
  displayName: string;
  fullyQualifiedName: string;
};

export const fetchGlossaryTermBasic = async (termFqn: string): Promise<GlossaryTermBasic> => {
  try {
    const encodedFqn = encodeOpenMetadataFqn(termFqn);
    const response = await openMetadataApiClient.get<GlossaryTermBasic>(`/glossaryTerms/name/${encodedFqn}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch glossary term basic info:', error);
    throw error;
  }
};
